export default __webpack_public_path__ + "static/analysts_Architect_INTJ_conclusion-5e38f589eb44f8812ca6888e86e70435.svg";